import { render, staticRenderFns } from "./ChatConversationList.vue?vue&type=template&id=edab5140&scoped=true"
import script from "./ChatConversationList.vue?vue&type=script&lang=js"
export * from "./ChatConversationList.vue?vue&type=script&lang=js"
import style0 from "./ChatConversationList.vue?vue&type=style&index=0&id=edab5140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edab5140",
  null
  
)

export default component.exports